"use client";
import type { HoverData } from "@casino/server/helpers/getHoverData";
import { createContext, useContext } from "react";

const HoverDataContext = createContext<HoverData | null>(null);

export const useHoverData = (minBet = 0) => {
  const data = useContext(HoverDataContext);
  if (!data) {
    return { isDepositToPlay: false };
  }
  const isDepositToPlay =
    !data.isMobile &&
    data.isLoggedIn &&
    data.isDepositToPlayEnabled &&
    data.userBalance <= minBet;
  return { isDepositToPlay };
};

export default HoverDataContext;
